import { call, takeLatest } from 'redux-saga/effects';

import ChangeLanguage from 'ia-react-core/~/actions/ChangeLanguage';
import REDUX from '../../../constants/REDUX';
import changeLanguage from '../../../actions/fn/changeLanguage';
import Translation from '../../../services/translation/Translation';

function* languageSaga(action: ChangeLanguage) {
  // eslint-disable-next-line @typescript-eslint/unbound-method
  yield call([Translation, Translation.changeLanguage], action.locale);
}

export default function* saga() {
  yield takeLatest(REDUX.CHANGE_LANGUAGE, languageSaga);
  yield takeLatest(changeLanguage.type, languageSaga);
}
